import { type Formats, useTranslations } from '../intl-custom'

// Since next-intl handles message loading through getRequestConfig,
// we can use a generic type for the translation keys
export type MessagesKeys = string

type TTranslate = (
  key: MessagesKeys,
  values?: Record<string, string | number | Date>,
  formats?: Formats,
) => string

type TTranslateRich = ReturnType<typeof useTranslations<MessagesKeys>>

export const useTranslate: () => {
  t: TTranslate
  tRich: TTranslateRich
} = () => {
  const t = useTranslations<MessagesKeys>() as TTranslate
  const tRich = useTranslations<MessagesKeys>()
  return { t, tRich }
}
